'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = setAnalyticsSaga;

var _effects = require('redux-saga/effects');

var _cookiesJs = require('cookies-js');

var _cookiesJs2 = _interopRequireDefault(_cookiesJs);

var _reduceAnalytics = require('../../actions/context/reduceAnalytics');

var _reduceAnalytics2 = _interopRequireDefault(_reduceAnalytics);

var _getDomain = require('../../helpers/getDomain');

var _getDomain2 = _interopRequireDefault(_getDomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(setAnalyticsSaga);

function setAnalyticsSaga(action) {
    var analytics, options, cookie, jsonCookie;
    return regeneratorRuntime.wrap(function setAnalyticsSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    analytics = action.payload;
                    options = { domain: (0, _getDomain2.default)(), expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)) };
                    cookie = {};
                    jsonCookie = _cookiesJs2.default.get('_metrix');

                    if (jsonCookie) {
                        cookie = JSON.parse(jsonCookie);
                    }
                    cookie.analytics = analytics;
                    _cookiesJs2.default.set('_metrix', JSON.stringify(cookie), options);
                    _context.next = 9;
                    return (0, _effects.put)((0, _reduceAnalytics2.default)(analytics));

                case 9:
                    return _context.abrupt('return', analytics);

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}